var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"footer frosted-bg",attrs:{"fluid":""}},[_c('b-row',{staticClass:"d-flex justify-content-center py-2 footer-text",attrs:{"align-h":"center"}},[_c('span',[_vm._v("©2022 – "+_vm._s(this.currentYear))]),_c('span',{staticClass:"px-1"},[_c('GithubLogo')],1),_c('span',[_vm._v("The EV Finder")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }